export class Zone {
    Id: number;
    Name: string;
    Status: string;
    ApplicationId: number;
    BusinessId: number;
}